import * as React from 'react';
import cn from 'classnames';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';
import * as Styles from '../Icon.module.scss';

export const PersonIcon = ({ fill = 'gcBlue', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);

    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                className={fillStyles}
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1C5.92487 1 1 5.92487 1 12C1 15.2399 2.40073 18.1527 4.62963 20.1657C4.64133 20.1768 4.65334 20.1876 4.66563 20.1981C6.61186 21.9405 9.1822 23 12 23C14.8176 23 17.3877 21.9406 19.3339 20.1985C19.3465 20.1877 19.3588 20.1767 19.3708 20.1653C21.5995 18.1523 23 15.2397 23 12C23 5.92488 18.0751 1 12 1ZM18.8622 17.8235C20.1956 16.2538 21 14.2209 21 12C21 7.02945 16.9705 3 12 3C7.02943 3 3 7.02943 3 12C3 14.2209 3.80442 16.2539 5.13779 17.8235C6.06741 16.6939 7.46983 16 9 16H15C16.5302 16 17.9326 16.6939 18.8622 17.8235ZM6.59911 19.2C8.10345 20.3302 9.97351 21 12 21C14.0265 21 15.8965 20.3302 17.4009 19.2C16.8455 18.4599 15.9652 18 15 18H9C8.03481 18 7.15448 18.4599 6.59911 19.2ZM7 9.5C7 6.73857 9.23857 4.5 12 4.5C14.7614 4.5 17 6.73859 17 9.5C17 12.2614 14.7614 14.5 12 14.5C9.23859 14.5 7 12.2614 7 9.5ZM15 9.5C15 7.84316 13.6568 6.5 12 6.5C10.3431 6.5 9 7.84314 9 9.5C9 11.1568 10.3432 12.5 12 12.5C13.6568 12.5 15 11.1568 15 9.5Z"
            />
        </svg>
    );
};
